<template>
  <v-dialog v-model="show" persistent width="500" v-if="show">
    <v-card>
      <v-card-title class="d-flex justify-space-between">
        <div v-if="tab < 3">Generate QR code and form</div>
        <div v-else></div>
        <v-btn fab text small @click="$emit('close')" right>
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-tabs-items v-model="tab">
          <v-tab-item>
            <!---Start: Encapsulate the tab form elements with v-form tag and v-model it. 
            This will automatically hold the state of form whether it it is valid or not
             as per rules defined on input fields--->
            <v-form v-model="isStepOneValid" ref="firstStepForm">
              <v-row dense>
                <v-col cols="12" md="12">
                  <div class="text-subtitle-1 font-weight-bold">
                    Source/Event Name
                  </div>
                </v-col>
                <v-col cols="12" md="12">
                  <v-text-field
                    v-model="myBusinessNetwork.eventName"
                    autofocus
                    label="Event Name"
                    outlined
                    single-line
                    placeholder="Event Name"
                    dense
                    :rules="requiredRules"
                    validate-on-blur
                  />
                </v-col>
                <!---Added validate-on-blur to above text field prop to text field to prevent text field from being in error state (red) before user has finished typing--->
                <!-- <v-col cols="12" md="12">
                  <div class="text-subtitle-1 font-weight-bold">
                    Link to your Privacy Policy
                  </div>
                  <div class="font-weight-regular">
                    Linking to your privacy policy in the submission form is
                    crucial for protecting privacy and ensuring compliance
                  </div>
                </v-col>
                <v-col cols="12" md="12">
                  <v-text-field
                    v-model="myBusinessNetwork.privacyPolicyURL"
                    label="Privacy Policy link"
                    outlined
                    single-line
                    placeholder="https://www.yourlink.com/privacy-policy"
                    dense
                    validate-on-blur
                    :rules="requiredRules"
                  />
                </v-col> -->
              </v-row>
            </v-form>
          </v-tab-item>
          <v-tab-item>
            <v-row>
              <v-col cols="6" md="6" sm="6">
                <div class="font-weight-regular">
                  Upload a logo for your QR code
                </div>
              </v-col>
            </v-row>
            <v-row>
              <UploadImageDialog
                :show="showUploadImageDialog"
                isDisplayImage
                previewType="square"
                @close="showUploadImageDialog = false"
                @uploaded="handleUploaded"
                :applyImageCompression="true"
                ref="uploadImageDialog"
                :isBadgeOrQrCode="true"
                :uploadToBusinessProfile="false"
              />
              <v-col cols="6" md="6" sm="6">
                <div v-if="showImage === false">
                  <AddNewImage
                    @click="showUploadImageDialog = true"
                    :size="170"
                    text="Upload a logo"
                  />
                </div>
                <div v-else>
                  <v-hover v-slot="{ hover }">
                    <v-img
                      :src="selectedImage"
                      width="170"
                      height="170"
                      class="qr-code-image"
                    >
                      <div class="text-right mt-2 mr-2" v-show="hover">
                        <AvatarButton
                          icon="mdi-image"
                          tooltipText="Change image"
                          @click="showUploadImageDialog = true"
                          className="d-inline-block mr-2"
                        />

                        <AvatarButton
                          icon="mdi-trash-can"
                          tooltipText="Delete image"
                          @click="handleDeleteImage"
                          className="d-inline-block"
                        />
                      </div>
                    </v-img>
                  </v-hover>
                </div>
              </v-col>
              <v-col cols="6" md="6" sm="6">
                <QRCode
                  ref="myQRCode"
                  :link="myBusinessNetwork.dynamicLink"
                  :logo="selectedImage"
                  :showDownloadButton="false"
                  :size="165"
                />
              </v-col>
            </v-row>

            <div class="text-left red--text" v-if="imageError">
              Please upload an image
            </div>
          </v-tab-item>
          <v-tab-item>
            <v-row>
              <v-col cols="12" md="12" sm="12">
                <div class="font-weight-regular">
                  Select the textfield's to include in the form
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-sheet class="rounded-lg pa-4" color="#f6f6f6">
                  <div class="d-flex justify-space-between">
                    <div class="text-subtitle-1">First and Last name</div>
                    <div>
                      <v-switch
                        class="mt-0"
                        v-model="myBusinessNetwork.isNameSwitchedOn"
                      ></v-switch>
                    </div>
                  </div>
                  <v-divider />
                  <div v-if="myBusinessNetwork.isNameSwitchedOn">
                    <v-radio-group
                      mandatory
                      v-model="myBusinessNetwork.isNameRequired"
                      row
                    >
                      <v-radio
                        color="#516077"
                        :value="true"
                        off-icon="mdi-circle-outline"
                        on-icon="mdi-check-circle"
                        label="Required"
                      ></v-radio>

                      <v-radio
                        color="#516077"
                        :value="false"
                        off-icon="mdi-circle-outline"
                        on-icon="mdi-check-circle"
                        label="Optional"
                      ></v-radio>
                    </v-radio-group>
                  </div>
                </v-sheet>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-sheet class="rounded-lg pa-4" color="#f6f6f6">
                  <div class="d-flex justify-space-between">
                    <div class="text-subtitle-1">City</div>
                    <div>
                      <v-switch
                        class="mt-0"
                        v-model="myBusinessNetwork.isCitySwitchedOn"
                      ></v-switch>
                    </div>
                  </div>
                  <v-divider />
                  <div v-if="myBusinessNetwork.isCitySwitchedOn">
                    <v-radio-group
                      mandatory
                      v-model="myBusinessNetwork.isCityRequired"
                      row
                    >
                      <v-radio
                        color="#516077"
                        :value="true"
                        off-icon="mdi-circle-outline"
                        on-icon="mdi-check-circle"
                        label="Required"
                      ></v-radio>

                      <v-radio
                        color="#516077"
                        :value="false"
                        off-icon="mdi-circle-outline"
                        on-icon="mdi-check-circle"
                        label="Optional"
                      ></v-radio>
                    </v-radio-group>
                  </div>
                </v-sheet>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-sheet class="rounded-lg pa-4" color="#f6f6f6">
                  <div class="d-flex justify-space-between">
                    <div class="text-subtitle-1">Country</div>
                    <div>
                      <v-switch
                        class="mt-0"
                        v-model="myBusinessNetwork.isCountrySwitchedOn"
                      ></v-switch>
                    </div>
                  </div>
                  <v-divider />
                  <div v-if="myBusinessNetwork.isCountrySwitchedOn">
                    <v-radio-group
                      mandatory
                      v-model="myBusinessNetwork.isCountryRequired"
                      row
                    >
                      <v-radio
                        color="#516077"
                        :value="true"
                        off-icon="mdi-circle-outline"
                        on-icon="mdi-check-circle"
                        label="Required"
                      ></v-radio>

                      <v-radio
                        color="#516077"
                        :value="false"
                        off-icon="mdi-circle-outline"
                        on-icon="mdi-check-circle"
                        label="Optional"
                      ></v-radio>
                    </v-radio-group>
                  </div>
                </v-sheet>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-sheet class="rounded-lg pa-4" color="#f6f6f6">
                  <div class="d-flex justify-space-between">
                    <div class="text-subtitle-1">Email</div>
                    <div>
                      <v-switch
                        class="mt-0"
                        v-model="myBusinessNetwork.isEmailSwitchedOn"
                      ></v-switch>
                    </div>
                  </div>
                  <v-divider />
                  <div v-if="myBusinessNetwork.isEmailSwitchedOn">
                    <v-radio-group
                      mandatory
                      v-model="myBusinessNetwork.isEmailRequired"
                      row
                    >
                      <v-radio
                        color="#516077"
                        :value="true"
                        off-icon="mdi-circle-outline"
                        on-icon="mdi-check-circle"
                        label="Required"
                      ></v-radio>

                      <v-radio
                        color="#516077"
                        :value="false"
                        off-icon="mdi-circle-outline"
                        on-icon="mdi-check-circle"
                        label="Optional"
                      ></v-radio>
                    </v-radio-group>
                  </div>
                </v-sheet>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-sheet class="rounded-lg pa-4" color="#f6f6f6">
                  <div class="d-flex justify-space-between">
                    <div class="text-subtitle-1">Mobile</div>
                    <div>
                      <v-switch
                        class="mt-0"
                        v-model="myBusinessNetwork.isMobileSwitchedOn"
                      ></v-switch>
                    </div>
                  </div>
                  <v-divider />
                  <div v-if="myBusinessNetwork.isMobileSwitchedOn">
                    <v-radio-group
                      mandatory
                      v-model="myBusinessNetwork.isMobileRequired"
                      row
                    >
                      <v-radio
                        color="#516077"
                        :value="true"
                        off-icon="mdi-circle-outline"
                        on-icon="mdi-check-circle"
                        label="Required"
                      ></v-radio>

                      <v-radio
                        color="#516077"
                        :value="false"
                        off-icon="mdi-circle-outline"
                        on-icon="mdi-check-circle"
                        label="Optional"
                      ></v-radio>
                    </v-radio-group>
                  </div>
                </v-sheet>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-sheet class="rounded-lg pa-4" color="#f6f6f6">
                  <div class="d-flex justify-space-between">
                    <div class="text-subtitle-1">Business Name</div>
                    <div>
                      <v-switch
                        class="mt-0"
                        v-model="myBusinessNetwork.isBusinessNameSwitchedOn"
                      ></v-switch>
                    </div>
                  </div>
                  <v-divider />
                  <div v-if="myBusinessNetwork.isBusinessNameSwitchedOn">
                    <v-radio-group
                      mandatory
                      v-model="myBusinessNetwork.isBusinessNameRequired"
                      row
                    >
                      <v-radio
                        color="#516077"
                        :value="true"
                        off-icon="mdi-circle-outline"
                        on-icon="mdi-check-circle"
                        label="Required"
                      ></v-radio>

                      <v-radio
                        color="#516077"
                        :value="false"
                        off-icon="mdi-circle-outline"
                        on-icon="mdi-check-circle"
                        label="Optional"
                      ></v-radio>
                    </v-radio-group>
                  </div>
                </v-sheet>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-sheet class="rounded-lg pa-4" color="#f6f6f6">
                  <div class="d-flex justify-space-between">
                    <div class="text-subtitle-1">Job Title</div>
                    <div>
                      <v-switch
                        class="mt-0"
                        v-model="myBusinessNetwork.isJobTitleSwitchedOn"
                      ></v-switch>
                    </div>
                  </div>
                  <v-divider />
                  <div v-if="myBusinessNetwork.isJobTitleSwitchedOn">
                    <v-radio-group
                      mandatory
                      v-model="myBusinessNetwork.isJobTitleRequired"
                      row
                    >
                      <v-radio
                        color="#516077"
                        :value="true"
                        off-icon="mdi-circle-outline"
                        on-icon="mdi-check-circle"
                        label="Required"
                      ></v-radio>

                      <v-radio
                        color="#516077"
                        :value="false"
                        off-icon="mdi-circle-outline"
                        on-icon="mdi-check-circle"
                        label="Optional"
                      ></v-radio>
                    </v-radio-group>
                  </div>
                </v-sheet>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-sheet class="rounded-lg pa-4" color="#f6f6f6">
                  <div class="d-flex justify-space-between">
                    <div class="text-subtitle-1">Note</div>
                    <div>
                      <v-switch
                        class="mt-0"
                        v-model="myBusinessNetwork.isNoteSwitchedOn"
                      ></v-switch>
                    </div>
                  </div>
                  <v-divider />
                  <div v-if="myBusinessNetwork.isNoteSwitchedOn">
                    <v-radio-group
                      mandatory
                      v-model="myBusinessNetwork.isNoteRequired"
                      row
                    >
                      <v-radio
                        color="#516077"
                        :value="true"
                        off-icon="mdi-circle-outline"
                        on-icon="mdi-check-circle"
                        label="Required"
                      ></v-radio>

                      <v-radio
                        color="#516077"
                        :value="false"
                        off-icon="mdi-circle-outline"
                        on-icon="mdi-check-circle"
                        label="Optional"
                      ></v-radio>
                    </v-radio-group>
                  </div>
                </v-sheet>
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item>
            <div class="text-center">
              <v-avatar color="#FDE1D6" size="70" class="mt-2">
                <v-icon dark color="primary" large> mdi-check </v-icon>
              </v-avatar>
            </div>
            <v-row>
              <v-col
                cols="12"
                sm="12"
                md="12"
                class="text-h6 font-weight-bold text-center"
              >
                Your QR code for {{ myBusinessNetwork.eventName }} has been
                generated
              </v-col>
            </v-row>
            <div
              class="d-flex flex-column justify-space-between align-center"
              style="height: 100px"
            >
              <v-btn
                width="200"
                depressed
                large
                class="primary"
                @click="handleDownloadQRCode"
              >
                Download QR Code
              </v-btn>

              <v-spacer></v-spacer>

              <v-btn
                width="200"
                depressed
                large
                class="primary"
                @click="handleCopyLink"
              >
                Copy Link to form
              </v-btn>
            </div>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
      <v-card-actions class="d-flex justify-end px-4" v-if="tab < 3">
        <div class="mr-9">
          <v-btn
            width="100"
            depressed
            large
            color="grey lighten-4"
            @click="handleBack"
          >
            Back
          </v-btn>
        </div>

        <div class="mr-2">
          <v-btn
            width="100"
            depressed
            large
            class="primary"
            @click="handleNext"
          >
            {{ nextButtonText }}
          </v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import vue2Dropzone from "vue2-dropzone";
import QRCode from "@/components/QRCode";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import AddNewImage from "@/components/AddNewImage";
import UploadImageDialog from "@/components/UploadImageDialog";
import AvatarButton from "@/components/AvatarButton";
import YourBusinessNetwork from "@/models/YourBusinessNetwork.js";
import { mapActions, mapGetters } from "vuex";
import Utility from "@/shared/utility";
let uuid = require("uuid");

export default {
  components: {
    vueDropzone: vue2Dropzone,
    AddNewImage,
    UploadImageDialog,
    QRCode,
    AvatarButton,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dropzoneOptions: {
        url: "https://httpbin.org/post",
        thumbnailWidth: 150,
        thumbnailHeight: 150,
        addRemoveLinks: false,
        acceptedFiles: ".jpg, .jpeg, .png",
      },
      showUploadImageDialog: false,
      selectedImage: require("@/assets/icons/addNewImage.svg"),
      showImage: false,
      myBusinessNetwork: {},
      requiredRules: [(v) => !!v || "This field is required"],
      isStepOneValid: false,
      imageError: false,
      tab: 0,
    };
  },
  created() {
    this.myBusinessNetwork = new YourBusinessNetwork({
      id: uuid.v1(),
      businessProfileId: this.selectedBusinessProfileId,
      createdBy: this.userProfile.firstName + " " + this.userProfile.lastName,
      created: new Date().toISOString(),
      qrCodeURL: this.selectedImage,
    });
  },
  computed: {
    ...mapGetters(["selectedBusinessProfileId", "userProfile"]),
    nextButtonText() {
      if (this.tab > 1) {
        return "Done";
      } else {
        return "Next";
      }
    },
  },
  watch: {
    // show: function (newValue) {
    //   if (!newValue) {
    //     this.tab = 0;
    //     this.myBusinessNetwork = {};

    //   }
    // },
  },
  methods: {
    ...mapActions(["showSnackbar"]),
    async handleNext() {
      // https://pappyonstaging.web.app //change to this when deploying
      let urlPrefix =
        process.env.NODE_ENV == "production"
          ? "https://business.pappyon.com"
          : "https://pappyon-staging.web.app";

      this.myBusinessNetwork.qrCodeURL = this.selectedImage;
      if (this.tab === 0) {
        this.myBusinessNetwork.dynamicLink =
          urlPrefix + "/form" + "/" + this.myBusinessNetwork.id;

        if (this.$refs.firstStepForm.validate()) {
          this.tab += 1;

          return;
        }
      } else if (this.tab === 1) {
        if (this.selectedImage !== "") {
          this.tab += 1;

          return;
        } else {
          this.imageError = true;
          return;
        }
      } else if (this.tab === 2) {
        this.tab += 1;
        this.myBusinessNetwork.save();
        return;
      }
    },
    handleBack() {
      this.tab -= 1;
    },
    handleUploaded(downloadURL) {
      console.log(downloadURL);
      this.selectedImage = downloadURL;
      this.imageError = false;
      this.showImage = true;
    },
    handleDeleteImage() {
      this.selectedImage = "";
      this.showImage = false;
    },
    handleDownloadQRCode() {
      this.$refs.myQRCode.downloadQRCode();
      
    },
    handleCopyLink() {
      Utility.copyToClipboard(this.myBusinessNetwork.dynamicLink);
      this.showSnackbar({ show: true, text: "Link copied to clipboard!" });
    
    },
  },
};
</script>

<style>
.qr-code-image {
  border: 1px solid #ededed;
}
.control-container {
  background: #f6f6f6;
  border-radius: 8px;
}
</style>